import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
export type MemberPrStatistics = {
  [login: string]: {
    last30DaysPRCount: number;
    last30DaysReviewedLines: number;
  };
};
type MemberPrStatisticsResponse = {
  memberStatistics: MemberPrStatistics;
};
export function useInstallationMembersStatistics(installationId) {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== installationId) {
    t0 = ["installation-members-statistics", installationId];
    t1 = async () => {
      if (!installationId) {
        return {
          memberStatistics: {}
        };
      }
      const response = await fetch(`/api/installation/members/statistics?installationId=${installationId}`, {
        method: "POST"
      });
      if (!response.ok) {
        throw new Error("Failed to fetch installation member statistics");
      }
      return response.json();
    };
    $[0] = installationId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = !!installationId;
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useQuery(t3);
}